<template>
  <div class="page" v-if="loaded">
    <div class="logo"></div>
    <div class="app">一个创造价值的<br>试玩APP</div>
    <div class="cont">
      <div class="icon"></div>
      <div class="name">OK赚</div>
      <div class="size" v-if="isIos">
        <span>快速安装，永不闪退</span>
      </div>
      <div class="size" v-else>
        <span>6.80 MB</span>
        <span>6275W <em>下载</em></span>
      </div>
      <div class="down" @click="down" ref="jsonAni"></div>
    </div>
    <div class="copyright">OK赚APP 版权所有</div>
    <!-- 微信和QQ，安卓显示引导 -->
    <template v-if="qqShow || wechatShow">
      <div class="layer">
        <div class="layer-android" :class="{ 'layer-ios': isIos }"></div>
      </div>
    </template>
    <template v-else-if="!isMobile">
      <div class="code-popup">
        <div class="code">
          <div id="qrcode" ref="qrcode"></div>
          <div>请使用手机扫码访问</div>
        </div>
      </div>
    </template>
    <div class="no-safari" v-else-if="isIos && !isSafari">
      <div class="no-cont">
        <div class="search">
          <i class="icon iconfont icon-sousuolan-da"></i>
          <span>{{ qrcodeUrl }}</span>
        </div>
        <div class="copy" @click="copy">复制</div>
        <div class="tip">安装《OK赚》，请点击【复制】按钮<br>并在Safari浏览器中打开</div>
      </div>
    </div>
  </div>
</template>

<script>
import Browser from "@/utils/browser";
import QRCode from 'qrcodejs2'
import lottie from "lottie-web";
import iosJson from "@/assets/json/btn.json";
import androidJson from "@/assets/json/android.json";
import { textCopy, getUrlParam, randomString } from "@/utils/common.js"
import { BaseUrl, appsUrl } from '@/utils/config';
export default {
  data() {
    return {
      data: {},
      loaded: false,
      qqShow: Browser.qq,
      wechatShow: Browser.wechat,
      isMobile: Browser.mobile,
      qrcodeUrl: window.location.href,
      isIos: Browser.ios,
      isAndroid: Browser.android,
      isSafari: Browser.safari,
      uid: '',
      type: '',
      isApps: 0,
    };
  },
  created() {
    this.isApps = this.$route.query.isApps == 1;
  },
  mounted() {
    this.uid = this.$route.params.id;
    if (this.$route.params.from == 'wx') {
      this.type = 'weixin';
    } else {
      this.type = this.$route.params.from;
    }
    this.install();//记录访问ip用
    this.inviteHome();
  },
  methods: {
    install() {
      this.axios.inviteUrl();
    },
    inviteHome() {
      if (this.type && this.$route.params.id) {
        let cookie_id = '';
        if ((getUrlParam("is_invite") != 1 && Browser.ios) || !Browser.ios) {
          const key = this.$route.params.id + "_" + this.type;
          cookie_id = localStorage.getItem(key) || randomString(16);
          localStorage.setItem(key, cookie_id);
        }
        this.axios.inviteHome({
          cookie_id,
          source_link: document.referrer || "-",
          uid: this.uid,
          from: this.type,
          channel: 1
        }).then(res => {
          if (res.data.code === 0) {
            this.data = res.data.data;
            this.loaded = true;
            this.$nextTick(() => {
              if (this.$refs.jsonAni) {
                lottie.loadAnimation({
                  container: this.$refs.jsonAni,
                  renderer: "svg",
                  loop: true,
                  autoplay: (this.qqShow || this.wechatShow) ? false : true,
                  animationData: this.isIos ? iosJson : androidJson,
                });
              }
            });
            if (this.isIos && this.isSafari && !this.qqShow && !this.wechatShow) {
              setTimeout(() => {
                this.openAppUrl();
              }, 3000);
            }
            this.$nextTick(() => {
              if (!this.isMobile) {
                this.showCode();
              }
            })
          }
        })
      } else {
        window.location.href = this.wwwDomain;
      }
    },
    showCode() {
      let qrcode = new QRCode('qrcode', {
        title: '使用微信《扫一扫》下载OK赚',
        width: 500, //图像宽度
        height: 500, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      })
      qrcode.clear() //清除二维码
      qrcode.makeCode(this.qrcodeUrl) //生成另一个新的二维码
    },
    copy() {
      textCopy(this.qrcodeUrl);
      this.$toast.show('链接已复制');
    },
    down() {
      var text = '';
      if (this.isIos) {
        text = '{"shifuID":"ok' + this.uid + '","activationKey":"' + this.code + '","type":"' + this.getType(this.type) + '","typeString":"' + this.type + '"}';
      } else {
        // 安卓
        text = '{"shifuID":"ok' + this.uid + '","type":"' + this.getType(this.type) + '","typeString":"' + this.type + '"}';
      }
      textCopy(text).then(() => {
        if (this.isAndroid) {
          window.location.href = this.data.install.DownloadUrl;
        } else if (this.isIos && this.isMobile) {
          if (this.data.payload_type == 2) {
            if (this.data.download_type == 1) {
              this.openAppUrl();
              return;
            } else {
              return;
            }
          }
        } else {
          this.$toast.show('请使用手机访问并下载');
        }
      })

      const key = this.uid + "_" + this.type;
      const vaule = localStorage.getItem(key);
      if (!vaule) return;

      this.axios.inviteHome({
        cookie_id: vaule,
        uid: this.uid,
        from: this.type,
        method: "click_stat"
      })
    },
    openAppUrl() {
      if (parent.frames.length == 0) {
        const url = window.location.href + (window.location.href.includes('?') ? "&" : "?") + "is_invite=1";
        window.location.href = (this.isApps ? appsUrl : BaseUrl) + 'ios/wapenter?url=' + url + '&json_url=' + encodeURIComponent(this.data.main_screen_url) + '&t=' + new Date().getTime();
      }
    },
    getType(typeString) {
      let arr = {
        'qq': "1",
        'qq_zone': "2",
        'weixin': "3",
        'weixin_zone': "4",
        'sina_weibo': "5",
        'qq_weibo': "",
        'erweima': "8",
        'link': "9",
        'invitecode': "10",
      }
      if (arr[typeString]) {
        return arr[typeString];
      }
      return 10;
    },
  }
};
</script>
<style lang="less" scoped>
@import "~@/assets/font/iconfont.css";

.page {
  height: 100vh;
  background-image: url(~@/assets/image/bg@3x.png);
  background-size: 100%;
  max-width: 540px;
  margin: 0 auto;

  .logo {
    width: 158px;
    height: 40px;
    margin: 0 auto;
    background-image: url(~@/assets/image/logo@3x.png);
    background-size: 100%;
  }

  .app {
    margin-top: 32px;
    font-weight: bold;
    font-size: 34px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }

  .cont {
    margin-top: -40px;
    height: 480px;
    background-image: url(~@/assets/image/pic_envelope@3x.png);
    background-size: 100%;
    padding-top: 164px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .icon {
      width: 64px;
      height: 64px;
      background-image: url(~@/assets/image/icon@3x.png);
      background-size: 100%;
    }

    .name {
      font-weight: 400;
      font-size: 24px;
      color: #333333;
      line-height: 34px;
      margin-top: 16px;
    }

    .size {
      margin-top: 8px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;

        em {
          font-weight: 400;
          font-size: 12px;
          color: #666666;
        }

        &:nth-child(2) {
          position: relative;
          margin-left: 26px;

          &::after {
            position: absolute;
            content: "";
            width: 2px;
            height: 9px;
            background: #dddddd;
            left: -12px;
            top: 6px;
          }
        }
      }
    }

    .down {
      width: 220px;
      margin: 0 auto;
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .copyright {
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 17px;
    text-align: center;
  }

  .layer {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20000;
    background: rgba(0, 0, 0, 0.7);

    .layer-android {
      float: right;
      width: 240px;
      height: 140px;
      background: url(~@/assets/image/android.png) center no-repeat;
      background-size: 100%;
      margin-top: 16px;
      margin-right: 20px;

      &.layer-ios {
        background: url(~@/assets/image/ios.png) center no-repeat;
        background-size: 100%;
      }
    }
  }

  .code-popup {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20000;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;

    .code {
      width: 200px;
      border-radius: 20px;
      background: #ffffff;
      padding-top: 12px;
      padding-bottom: 12px;
      display: flex;
      align-items: center;
      flex-direction: column;

      #qrcode {
        width: 150px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;

        /deep/img {
          width: 100%;
          height: 100%;
        }
      }

      div {
        font-weight: 400;
        margin-top: 12px;
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        text-align: center;
      }
    }
  }

  .no-safari {
    width: 100%;
    height: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;

    .no-cont {
      background: #ffffff;
      border-radius: 8px;
      width: 327px;
      height: 216px;
      margin: 0 auto;
      margin-left: 24px;
      margin-top: auto;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-top: 28px;
      box-sizing: border-box;

      .search {
        width: 272px;
        height: 42px;
        background: #f5f5f5;
        border-radius: 8px;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        padding: 0 12px;
        box-sizing: border-box;

        i {
          margin-right: 9px;
          font-size: 24px;
          color: #999999;
        }

        span {
          width: 212px;
          white-space: nowrap;
          overflow-x: scroll;
          font-size: 12px;
        }
      }

      .copy {
        width: 240px;
        height: 43px;
        background: #f44336;
        box-shadow: 0px 4 10px 0px rgba(244, 67, 54, 0.2);
        border-radius: 254px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        line-height: 16px;
      }

      .tip {
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 14px;
        margin-top: 19px;
        text-align: center;
      }
    }
  }
}
</style>
